// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"18dde605","952":"b15e8921"}[chunkId] + ".chunk.js";
};